module.exports = __webpack_public_path__ + "media/36.29c15a1c.mp3";